import { render, staticRenderFns } from "./DashboardCarousel.vue?vue&type=template&id=229db5cd&scoped=true&"
import script from "./DashboardCarousel.vue?vue&type=script&lang=js&"
export * from "./DashboardCarousel.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCarousel.vue?vue&type=style&index=0&id=229db5cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229db5cd",
  null
  
)

export default component.exports